export const CONTRAGENT_ROLE_OPTIONS = [
  "SUPPLIER",
  "CUSTOMER",
  "CARRIER",
  "BROKER",
  "MANUFACTURER",
] as const

export const CONTRAGENT_ROLE_LABELS: Record<
  (typeof CONTRAGENT_ROLE_OPTIONS)[number],
  string
> = {
  SUPPLIER: "Dostawca",
  CUSTOMER: "Klient",
  CARRIER: "Przewoźnik",
  BROKER: "Broker",
  MANUFACTURER: "Producent",
}

export const getContragentRoleLabel = (role: string) =>
  CONTRAGENT_ROLE_LABELS[role as keyof typeof CONTRAGENT_ROLE_LABELS] ?? role

export const CONTRAGENT_TYPE_OPTIONS = [
  { value: "ORGANIZATION", label: "Organizacja" },
  { value: "INDIVIDUAL", label: "Osoba fizyczna" },
] as const

export const ADDRESS_TYPE_OPTIONS = [
  { value: "LEGAL", label: "Adres prawny" },
  { value: "DELIVERY", label: "Adres dostawy" },
] as const

export const DELIVERY_DAY_OPTIONS = [
  "MON-FRI",
  "MON",
  "TUE",
  "WED",
  "THU",
  "FRI",
  "SAT",
] as const

export const CURRENCY_OPTIONS = [
  { value: "PLN", label: "PLN — Złoty polski" },
  { value: "EUR", label: "EUR — Euro" },
  { value: "USD", label: "USD — Dolar amerykański" },
  { value: "GBP", label: "GBP — Funt szterling" },
  { value: "CHF", label: "CHF — Frank szwajcarski" },
] as const

export const LANGUAGE_OPTIONS = [
  { value: "pl", label: "Polski (PL)" },
  { value: "en", label: "Angielski (EN)" },
  { value: "de", label: "Niemiecki (DE)" },
  { value: "uk", label: "Ukraiński (UK)" },
] as const

export const INCOTERMS_OPTIONS = [
  { value: "EXW", label: "EXW — Ex Works" },
  { value: "FCA", label: "FCA — Free Carrier" },
  { value: "CPT", label: "CPT — Carriage Paid To" },
  { value: "CIP", label: "CIP — Carriage and Insurance Paid to" },
  { value: "DAP", label: "DAP — Delivered at Place" },
  { value: "DPU", label: "DPU — Delivered at Place Unloaded" },
  { value: "DDP", label: "DDP — Delivered Duty Paid" },
  { value: "FOB", label: "FOB — Free on Board" },
  { value: "CIF", label: "CIF — Cost, Insurance and Freight" },
] as const
